import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import {MatTabsModule} from '@angular/material/tabs';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatListModule} from '@angular/material/list';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatDividerModule} from '@angular/material/divider';
import {MatBadgeModule} from '@angular/material/badge';
import {MatStepperModule} from '@angular/material/stepper';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

import { SelectReactivoComponent } from "./select-reactivo.component";
import { ReactivosComponent } from './reactivos/reactivos.component';
import { PreviewComponent } from './preview/preview.component';
import { TraduccionesComponent } from './traducciones/traducciones.component';
import { OrdenarReactivosComponent } from './ordenar-reactivos/ordenar-reactivos.component';

@NgModule({
  declarations: [SelectReactivoComponent, ReactivosComponent, PreviewComponent, TraduccionesComponent, OrdenarReactivosComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    TranslateModule,
    MatTabsModule,
    MatSidenavModule,
    MatListModule,
    MatButtonToggleModule,
    MatDividerModule,
    MatBadgeModule,
    MatStepperModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatButtonModule
  ]
})
export class SelectReactivoModule { }
